import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetPresignedDownloadURLForSurveyRulesRPC } from "./getPresignedDownloadUrlForSurveyRulesRPC";

export class GetPresignedDownloadURLForSurveyRulesRPCClientImpl extends GetPresignedDownloadURLForSurveyRulesRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetPresignedDownloadURLForSurveyRulesRPC.Request): Promise<LeoRPCResult<GetPresignedDownloadURLForSurveyRulesRPC.Response, GetPresignedDownloadURLForSurveyRulesRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-rules/GetPresignedDownloadURLForSurveyRules",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetPresignedDownloadURLForSurveyRulesRPC.ResponseDTO,
      GetPresignedDownloadURLForSurveyRulesRPC.Errors.ErrorsDTO,
      GetPresignedDownloadURLForSurveyRulesRPC.Response,
      GetPresignedDownloadURLForSurveyRulesRPC.Errors.Errors
    >(
      response,
      "survey-rules/GetPresignedDownloadURLForSurveyRules",
      GetPresignedDownloadURLForSurveyRulesRPC.Response.fromDTO,
      GetPresignedDownloadURLForSurveyRulesRPC.Errors.fromDTO
    );
  }
}
